<ng-container [formGroup]="form">
  <div
    class="wrapper"
    #tabWrapper
    *ngFor="let tab of series"
  >
    <input class="open-close-switcher" type="checkbox" #tabCheckbox/>
    <div
      class="tab"
      [style.backgroundColor]="tab.settings.color"
    >
      <div class="tab__actions-container" [style.backgroundColor]="tab.settings.color">
        <div class="actions" [formGroupName]="tab.id">
          <ng-container
            *ngIf="(tab.id === mainSeries.id || isHistorical) && card.chartId !== chartNameId.IV_DIFFERENCE">
            <ng-container *ngTemplateOutlet="baseStock; context: {tab: tab}"></ng-container>
          </ng-container>

          <ng-container *ngFor="let key in $any(form.controls[tab.id])?.controls">
            <ng-container
              *ngIf="(key !== filterTypes.DATE_TIME && key !== filterTypes.REALTIME) && card.chartId !== chartNameId.IV_DIFFERENCE">
              <ng-container *ngTemplateOutlet="dropdown; context: {tab: tab, controlName: key}"></ng-container>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="card.chartId === chartNameId.IV_DIFFERENCE">
            <div class="controls-frame">
              <span class="controls-frame__title">{{locale.firstPoint}}</span>

              <ng-container *ngIf="(form.controls[tab.id]?.get(filterTypes.STOCK_ID + '-first'))">
                <ng-container
                  *ngTemplateOutlet="ivDifferentStock; context: {tab: tab, stock: form.controls[tab.id].get(filterTypes.STOCK_ID + '-first').value, point: 'first'}"></ng-container>
              </ng-container>

              <ng-container *ngIf="(form.controls[tab.id]?.get(filterTypes.IVX_TERM + '-first'))">
                <ng-container
                  *ngTemplateOutlet="dropdown; context: {tab: tab, controlName: filterTypes.IVX_TERM + '-first', control: filterTypes.IVX_TERM + '-first'}"></ng-container>
              </ng-container>

              <ng-container *ngIf="(form.controls[tab.id]?.get(filterTypes.MONEYNESS + '-first'))">
                <ng-container
                  *ngTemplateOutlet="dropdown; context: {tab: tab, controlName: filterTypes.MONEYNESS + '-first', control: filterTypes.MONEYNESS + '-first'}"></ng-container>
              </ng-container>
            </div>

            <div class="controls-frame">
              <span class="controls-frame__title">{{locale.secondPoint}}</span>

              <ng-container *ngIf="(form.controls[tab.id]?.get(filterTypes.STOCK_ID + '-second'))">
                <ng-container
                  *ngTemplateOutlet="ivDifferentStock; context: {tab: tab, stock: form.controls[tab.id].get(filterTypes.STOCK_ID + '-second').value, point: 'second'}"></ng-container>
              </ng-container>

              <ng-container *ngIf="(form.controls[tab.id]?.get(filterTypes.IVX_TERM + '-second'))">
                <ng-container
                  *ngTemplateOutlet="dropdown; context: {tab: tab, controlName: filterTypes.IVX_TERM + '-second', control: filterTypes.IVX_TERM + '-second'}"></ng-container>
              </ng-container>

              <ng-container *ngIf="(form.controls[tab.id]?.get(filterTypes.MONEYNESS + '-second'))">
                <ng-container
                  *ngTemplateOutlet="dropdown; context: {tab: tab, controlName: filterTypes.MONEYNESS + '-second', control: filterTypes.MONEYNESS + '-second'}"></ng-container>
              </ng-container>
            </div>
          </ng-container>

          <div
            class="dx-box-hint-container"
            [ivLiveHint]="locale.timeRange"
            ivLiveHintPosition="top-right"
            *ngIf="mainSeries.id !== tab.id"
          >
            <iv-live-date-time-selector
              class="date-time"
              *ngIf="form.controls[tab.id]?.get(filterTypes.DATE_TIME)"
              [formControl]="$any(form.controls[tab.id]?.get(filterTypes.DATE_TIME))"
              [locale]="locale"
              [isActionControl]="true"
              [clearButton]="{date: false, time: false}"
              [container]="isFullScreen ? tabWrapper : undefined"
            ></iv-live-date-time-selector>
          </div>

          <div
            *ngIf="tab.id !== mainSeries.id"
            class="delete-series"
            (click)="deleteCompareSeries(card.id, tab.id, tab.settings.color)"
            statistic
            [statisticElementName]="'Delete series'"
            [ivLiveHint]="locale.deleteCompareSeries"
            ivLiveHintPosition="top-right"
          >
            <img
              src="./iv-live/assets/icons/chart-service/charts-icons/delete-series.svg"
              alt="delete-series"
            />
          </div>

          <div
            class="close-series-tab"
            (click)="close(tabCheckbox)"
            statistic
            [statisticElementName]="'Close chart'"
            [ivLiveHint]="locale.close"
            ivLiveHintPosition="top-right"
          >
            <img
              src="./iv-live/assets/icons/chart-service/charts-icons/close.svg"
              alt="close"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div
  class="compare-series"
  statistic
  [statisticElementName]="'Click compare-series'"
  [class.compare-series-display-none]="card.chartSeries.length === maxCountSeries"
  (click)="compareButtonFunc"
  [ivLiveHint]="locale.compareHint"
  ivLiveHintPosition="top-right"
>
  <span class="compare-series__plus">{{locale.comparePlus}}</span>

  <div class="compare-series__button">
    <span>{{locale.compare}}</span>
  </div>
</div>

<ng-template #baseStock let-tab="tab">
  <span
    class="select-series"
    [ivLiveHint]="tab.id === mainSeries.id ? locale.mainSeries : locale.compareChange"
    ivLiveHintPosition="top-right"
    (click)="changeSeries(card.id, tab.id)"
    statistic
    [statisticElementName]="'Click chart actions'"
  >
    {{getSeriesSymbol(tab.id)}}
  </span>
</ng-template>

<ng-template #ivDifferentStock let-tab="tab" let-stock="stock" let-point="point">
  <div
    class="select-series"
    [ivLiveHint]="locale.changeIvDiffStock"
    ivLiveHintPosition="top-right"
    (click)="changeIVDiffStockSeries(card.id, tab.id, point)"
    statistic
    [statisticElementName]="'Card chart control select main series'"
  >
    {{getIVDiffSymbol(tab.id, point)}}
  </div>
</ng-template>

<ng-template #dropdown let-tab="tab" let-controlName="controlName" let-control="control">
  <ng-container [formGroup]="$any(form.controls[tab.id])">
    <iv-live-dropdown-new
      class="chart-filter"
      [templateField]="dropdownTemplateField(controlName)"
      [withoutHover]="true"
      [rubberInput]="true"
      [formControlName]="controlName"
      [listValues]="$any(listsValues[tab.id][controlName])"
      [ivLiveHint]="locale[controlName]"
      [contentWidth]="contentWidth(controlName)"
      ivLiveHintPosition="top-right"
      withoutDivider
      [label]="getFilterLabel(controlName)"
      [isAutocomplete]="controlName === 'strike'"
    >
    </iv-live-dropdown-new>
  </ng-container>
</ng-template>
